import WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import type { GitBranchScope } from './resolve-git-branch-scope.js';
import { executeFileBrowserList } from './execute-file-browser-list.js';
import { sendFileBrowserMessage } from './send-file-browser-message.js';

export async function handleFileBrowserList(
  socket: WebSocket,
  e2ee: CliE2eeRuntime | undefined,
  id: string,
  reqPath: string,
  sessionParentPath: string | undefined,
  gitScope: GitBranchScope | null,
): Promise<void> {
  const result = await executeFileBrowserList({ reqPath, sessionParentPath, gitScope });

  if ('error' in result) {
    sendWsMessage(socket, { type: 'file_browser_response', id, error: result.error });
    return;
  }

  sendFileBrowserMessage(socket, e2ee, { type: 'file_browser_response', id, entries: result.entries });
}
